import axiosInstance from "../../axios/axiosInstance";
import { ERROR_REPORT_LISTING, SENT_REPORT_LISTING } from "../../constants";

export const getErrorLogListing = ({ skip, limit, search }) => onResponse => {
    const BASE_URL = `${ERROR_REPORT_LISTING}?skip=${skip}&limit=${limit}&search=${search}`;
    try {
        axiosInstance.get(BASE_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};


export const getErrorLogDetails = (id) => (onResponse) => {
    try {
        axiosInstance
            .get(ERROR_REPORT_LISTING + id)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });
    } catch (error) { }
};

export const getSentLogListing = ({ skip, limit, search, templateSearch, subjectSearch, filters }) => onResponse => {
    const queryParams = new URLSearchParams({
        skip: skip || 0,
        limit: limit || 10,
        emails: search || '',
        template_type: templateSearch || '',
        subject: subjectSearch || ''
    });

    // Exclude `selected_status` and add other filters
    if (filters) {
        Object.keys(filters).forEach(key => {
            if (key !== 'selected_status' && filters[key]) {
                queryParams.append(key, filters[key]);
            }
        });
    }

    const BASE_URL = `${SENT_REPORT_LISTING}?${queryParams.toString()}`;

    try {
        axiosInstance.get(BASE_URL)
            .then(response => onResponse(response.data))
            .catch(err => {
                console.log(err);
                onResponse(err);
            });
    } catch (error) {
        console.error(error);
    }
};

export const getSentLogDetails = (id) => (onResponse) => {
    try {
        axiosInstance
            .get(SENT_REPORT_LISTING + id)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });
    } catch (error) { }
};
